import { render, staticRenderFns } from "./DishesManagePage.vue?vue&type=template&id=506042c2&"
import script from "./DishesManagePage.vue?vue&type=script&lang=js&"
export * from "./DishesManagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports